import ajax from './request.js';

let bool = process.env.NODE_ENV === 'production';
const href = bool
  ? `https://${window.location.host}/api/cloud/canvasAi`
  : '/api/cloud/canvasAi';

function canvasAiChat(data) {
  return ajax(`${href}/chat`, {
    method: 'POST',
    data,
  });
}

function canvasAiHealth(data) {
  return ajax(`${href}/health`, {
    method: 'POST',
    data: data || { t: Date.now() },
  });
}

function canvasAiAdminList(data) {
  return ajax(`${href}/admin/list`, {
    method: 'POST',
    data: data || {},
  });
}

function canvasAiAdminVendors() {
  return ajax(`${href}/admin/vendors`, {
    method: 'POST',
    data: {},
  });
}

function canvasAiAdminSaveVendor(data) {
  return ajax(`${href}/admin/saveVendor`, {
    method: 'POST',
    data,
  });
}

function canvasAiAdminSave(data) {
  return ajax(`${href}/admin/save`, {
    method: 'POST',
    data,
  });
}

function canvasAiAdminToggle(data) {
  return ajax(`${href}/admin/toggle`, {
    method: 'POST',
    data,
  });
}

function canvasAiAdminDelete(data) {
  return ajax(`${href}/admin/delete`, {
    method: 'POST',
    data,
  });
}

function canvasAiSnapshotPush(data) {
  return ajax(`${href}/snapshot/push`, {
    method: 'POST',
    data,
  });
}

function canvasAiSnapshotPop(data) {
  return ajax(`${href}/snapshot/pop`, {
    method: 'POST',
    data,
  });
}

export default {
  canvasAiChat,
  canvasAiHealth,
  canvasAiSnapshotPush,
  canvasAiSnapshotPop,
  canvasAiAdminList,
  canvasAiAdminVendors,
  canvasAiAdminSaveVendor,
  canvasAiAdminSave,
  canvasAiAdminToggle,
  canvasAiAdminDelete,
};
